export default __webpack_public_path__ + "static/media/GraftCafe-1.dabe0fec.jpg";